module.exports = __webpack_public_path__ + "static/img/wangxing.c5d2438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/picture_show/wangxing.jpg
// module id = p8OB
// module chunks = 1